<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2024-01-02 16:41:59
!-->
<template>
	<div id="index" class="index">
		<div class="companyProfile">
			<div @click="clickType(item,index)" :class="['Company-Details',{'active':selectNumber == index}]"
				v-for="(item,index) in tabList" :key="index">
				{{item.title}}
			</div>
		</div>
		<CompanyDetails v-if="selectNumber == 0"></CompanyDetails>
		<Users v-if="selectNumber == 1"></Users>
	</div>
</template>

<script>
	import CompanyDetails from './companyDetails.vue'
	import Users from './users.vue'
	export default {
		components: {
			// 组件的引用
			CompanyDetails,
			Users
		},
		props: {
			// 父辈向子辈传参
		},
		name: "Index",
		data() {
			return {
				tabList: [{
						title: 'Company Details'
					},
					{
						title: 'Users'
					},
				],
				selectNumber: 0,
			};
		},
		computed: {
			// 计算属性
		},
		watch: {
			// 监测变化
		},
		mounted() {
			// 页面进入时加载内容
		},
		created() {
			// 实例被创建之后执行代码
		},
		methods: {
			clickType(item, index) {
				this.selectNumber = index
			},
		}
	}
</script>
<style scoped lang='scss'>
	.companyProfile {
		display: flex;
		justify-content: start;

		.active {
			max-width: 145px;
			min-width: 59px;
			height: 32px;
			line-height: 32px;
			background: #FFFFFF;
			border-radius: 6px;
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #E95506 !important;
			padding: 0 8px;
		}

		.Company-Details,
		.Users {
			font-size: 16px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			color: #777777;
			margin-right: 16px;
			line-height: 32px;
			cursor: pointer;
		}
	}
</style>